import Datepicker from 'vanillajs-datepicker/Datepicker';
import cs from 'vanillajs-datepicker/locales/cs';

Object.assign(Datepicker.locales, cs);

export function initialize() {
    console.log('testDatePickerInit');
    document.addEventListener('focusin', function (event ) {
        console.log('testDatePickerFocus');
        let element = event.target.closest('[data-datepicker]');

        if (element !== null) {
            console.log('testDatePickerHasElement');
            let datepicker = new Datepicker(element, {
                buttonClass: 'btn',
                language: element.dataset.datepicker
            });

            datepicker.show();

            let destroyDatepicker = function () {
                console.log('testDatePickerDestroy');
                datepicker.destroy();
                element.removeListener(destroyDatepicker);
            }

            element.addEventListener('focusout', destroyDatepicker);
        }
    });
}

